import React, { createContext, useContext, useEffect, useState } from "react";
import { GetApi } from "../api/api-service";
import { API_Path } from "../Const";

// Create context
export const AuthContext = createContext();

// Context provider
export default function AuthContextProvider({ children }) {
    const [areaUnits, setAreaUnits] = useState([]);
    const [amenityType, setAmenityType] = useState([]);
    const [completionType, setCompletionType] = useState([]);
    const [offeringType, setOfferingType] = useState([]);
    const [purposeType, setPurposeType] = useState([]);
    const [ppsSaleType, setPPSSaleType] = useState([]);
    const [categoriesType, setCategoriesType] = useState([]);
    const [furnishData, setFurnishData] = useState([]);
    const [facingData, setFacingData] = useState([]);
    const [facingViewData, setFacingViewData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [specialities, setSpecialities] = useState([]);
    const [devNames, SetDevNames] = useState([]);
    

    // Fetch area units only once when app starts
    useEffect(() => {
        // fetchCompletionType();
        // fetchOfferingType();
    }, []);

    const fetchDevNames = async () => {
        try {
            const res = await GetApi(API_Path.selectDevName);
            if (res?.data) SetDevNames(res.data.data);
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };
    const fetchAreaUnits = async () => {
        try {
            const res = await GetApi(API_Path.AreaUnits);
            if (res?.data) setAreaUnits(res.data.data);
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };
    const fetchAmenityType = async () => {
        try {
            const res = await GetApi(API_Path.amenityType);
            if (res?.data) setAmenityType(res.data.data);
        } catch (error) {
            console.error("Error fetching amenity type:", error);
        }
    };
    const fetchCompletionType = async () => {
        try {
            const res = await GetApi(API_Path.completionType);
            if (res?.data) setCompletionType(res.data.data);
        } catch (error) {
            console.error("Error fetching completion type:", error);
        }
    };
    const fetchOfferingType = async () => {
        try {
            const res = await GetApi(API_Path.offeringType);
            if (res?.data) setOfferingType(res.data.data);
        } catch (error) {
            console.error("Error fetching offering type:", error);
        }
    };
    const fetchPurposeType = async () => {
        try {
            const res = await GetApi(API_Path.purposeType);
            if (res?.data) setPurposeType(res.data.data);
        } catch (error) {
            console.error("Error fetching purpose type:", error);
        }
    };
    const fetchPPSSaleType = async () => {
        try {
            const res = await GetApi(API_Path.purposeSaleType);
            if (res?.data) setPPSSaleType(res.data.data);
        } catch (error) {
            console.error("Error fetching purpose sale type:", error);
        }
    };
    const fetchCategoriesType = async () => {
        try {
            const res = await GetApi(API_Path.categoriesType);
            if (res?.data) setCategoriesType(res.data.data);
        } catch (error) {
            console.error("Error fetching categories type:", error);
        }
    };
    const fetchFurnishType = async () => {
        try {
            const res = await GetApi(API_Path.furnishType);
            if (res?.data) setFurnishData(res.data.data);
        } catch (error) {
            console.error("Error fetching furnish type:", error);
        }
    };
    const fetchfacingDirectionType = async () => {
        try {
            const res = await GetApi(API_Path.facingDirectionType);
            if (res?.data) setFacingData(res.data.data);
        } catch (error) {
            console.error("Error fetching facing direction type:", error);
        }
    };
    const fetchFacingViewType = async () => {
        try {
            const res = await GetApi(API_Path.facingViewType);
            if (res?.data) setFacingViewData(res.data.data);
        } catch (error) {
            console.error("Error fetching facing view type:", error);
        }
    };

    const fatchCity = async () => {
        try {
            const res = await GetApi(API_Path.fatchCities);
            if (res?.data?.success) setCityData(res.data.data);
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };
    const fatchLanguages = async () => {
        try {
            const res = await GetApi(API_Path.fatchLanguages);
            if (res?.data?.success) setLanguages(res.data.data);
        } catch (error) {
            console.error("Error fetching languages:", error);
        }
    };
    const fatchSpecialities = async () => {
        try {
            const res = await GetApi(API_Path.fatchSpecialities);
            if (res?.data?.success) setSpecialities(res.data.data);
        } catch (error) {
            console.error("Error fetching specialities:", error);
        }
    };

    return (
        <AuthContext.Provider value={{ areaUnits, fetchAreaUnits, amenityType,fetchAmenityType, completionType,fetchCompletionType, purposeType, fetchPurposeType, categoriesType, fetchCategoriesType, offeringType,fetchOfferingType, furnishData, fetchFurnishType,facingData,fetchfacingDirectionType,facingViewData ,fetchFacingViewType,ppsSaleType,fetchPPSSaleType,cityData,fatchCity ,languages,fatchLanguages,specialities,fatchSpecialities,devNames,fetchDevNames}}>
            {children}
        </AuthContext.Provider>
    );
}

// Custom hook for accessing context
export function useAuth() {
    return useContext(AuthContext);
}
